import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { ViewOptionsState } from '../shared-state.interface';
import { ViewOptionsAction, ViewOptionsActionTypes } from './view-options.actions';
import { ViewOptions } from './view-options.entity';

export const viewOptionsAdapter: EntityAdapter<ViewOptions> = createEntityAdapter<ViewOptions>({
    selectId: viewOptions => viewOptions.view
});
export const emptyViewOptionsState: ViewOptionsState = viewOptionsAdapter.getInitialState();

export function ViewOptionsReducer(state = emptyViewOptionsState, action: Action): ViewOptionsState {
    const viewOptionsAction: ViewOptionsAction = action as ViewOptionsAction;
    switch (viewOptionsAction.type) {
        case ViewOptionsActionTypes.SetFiltersPanelState: {
            return viewOptionsAdapter.upsertOne(
                {
                    view: viewOptionsAction.view,
                    filtersPanelOpen: viewOptionsAction.opened
                },
                state
            );
        }

        case ViewOptionsActionTypes.SetRecordTreePanelState: {
            return viewOptionsAdapter.upsertOne(
                {
                    view: viewOptionsAction.view,
                    recordTreePanelOpen: viewOptionsAction.opened
                },
                state
            );
        }

        default:
            return state;
    }
}
